/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
  Upload,
  Row,
  Col,
  Typography,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState, useMemo,} from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  DeleteOutlined,
  UploadOutlined,
  FormOutlined,
  ApartmentOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { dataTo12Fn } from "@/utils/date";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModalSummary";
import EditModal from "./component/editModal";
import UploadModal from "./component/uploadModal";
import UploadToExcelModal from "./component/uploadExcelModal";
import UploadLiabilityModal from "./component/uploadLiabilityModal";
// import InsuranceModal from './component/insuranceModal';
import "./component/index.css";
export default function InsuranceIndex() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const ViewModalRef = useRef(null);
  const UploadModalRef = useRef(null);
  const UploadToExcelModalRef = useRef(null);
  const uploadLiabilityModalRef = useRef(null);
  const insuranceModalRef = useRef(null);
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [anetTypeOptions, AnetTypeOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState([]);
  const [highlightRowId, setHighlightRowId] = useState(null);
  // 上传Excel
  const [pendingFile, setPendingFile] = useState(null);
  const [checkModalVisible, setCheckModalVisible] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [checkMsg, setCheckMsg] = useState("");
  const buildColumns = (checkedValues = selectedItems) =>
    initColumns.map((item) => ({
      ...item,
      hidden:
        checkedValues?.length > 0
          ? !checkedValues.includes(item.dataIndex)
          : false,
    }));

  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(buildColumns(checkedValues));
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    if (e.key === "Edit") {
     addModalRef.current?.setModelEdit(record);
    }
    if (e.key === "Delete") {
      Modal.confirm({
        title: "Confirm Delete",
        content: "Are you sure you want to delete this policy?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk: async () => {
          try {
            const res = await http.get(api.getInsuranceSummaryDel, {
              params: { id: record?.id },
            });
            if (res?.code === "1") {
              message.success("Delete Successfully.");
              getTableListFn(
                pagination.current,
                pagination.pageSize,
                tableHead,
              );
            } else {
              message.error(res?.msg);
            }
          } catch (err) {
            message.error("Request Error");
          }
        },
      });
    }
     if (e.key === "NewPolicy") {
      // insuranceModalRef.current?.open(record);
      // return;
       const encodedRecord = encodeURIComponent(JSON.stringify(record));
        window.open(`/#/AccountPayable/InsurancePage?id=${record.id}&summaryRecord=${encodedRecord}`, "_blank");
       }
  };

  const getAgentTypeList = async () => {
    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;
      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));

      AnetTypeOptions(list);
    } catch (err) {
      message.error("Request Error");
    }
  };
  const AnetTypeMap = useMemo(() => {
    const map = {};
    anetTypeOptions.forEach((item) => {
      map[item.value] = item.label;
    });
    return map;
  }, [anetTypeOptions]);

  const initTableHead = {
   carrier: null,
  agent: null,
  payee: null,
  remark: null,
  effectiveDate: null,
  expirationDate: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    if (type === "DatePicker") {
      setTableHead((prev) => {
        const updatedTableHead = {
          ...prev,
          // [key]: event || undefined,
          [key]: event ? event.format("YYYY-MM-DD") : undefined,
        };
        getTableListFn(1, pagination.pageSize, updatedTableHead);
        return updatedTableHead;
      });
      return;
    }
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => {
        const menuItems = [
          commonFn.btnAuthorityFlag("Edit") && {
            key: "Edit",
            icon: <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Edit </div>,
          },
          commonFn.btnAuthorityFlag("Delete") && {
            key: "Delete",
            icon: <DeleteOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Delete </div>,
          },
            commonFn.btnAuthorityFlag("NewPolicy") && {
            key: "NewPolicy",
            icon: <ApartmentOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>New Policy </div>,
          },
        ].filter(Boolean);

        return (
          (menuItems.length > 0 && (
            <Dropdown
              menu={{
                items: menuItems,
                onClick: (e) => handleMenuClick(e, record),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
              />
            </Dropdown>
          )) ||
          null
        );
      },
    },

    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      // tableFilterFn(dateString, "expirationDate", "DatePicker"),
      onChange: (date) => tableFilterFn(date, "expirationDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      // tableFilterFn(dateString, "effectiveDate", "DatePicker"),
      onChange: (date) => tableFilterFn(date, "effectiveDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },


    {
      title: "Carrier",
      dataIndex: "carrier",
      titleType: "Input",
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "carrier"),
    },
    {
      title: "Agent",
      dataIndex: "agent",
      titleType: "Select",
      sortterMultiple: 3,
      selectOptions: anetTypeOptions,
      onChange: (e) => tableFilterFn(e, "agent", "Select"),
    },
      {
      title: "Payee",
      dataIndex: "payee",
      titleType: "Select",
      sortterMultiple: 3,
      selectOptions: anetTypeOptions,
      onChange: (e) => tableFilterFn(e, "payee", "Select"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
    },

  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getInsuranceSummary, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.id,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter;
    if (columnKey === "trust") {
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      };
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
    setColumns(buildColumns(transformedList2));
  };

  useEffect(() => {
    initColunmsFn();
    getAgentTypeList();
    getTableListFn(1, 25);
  }, [refreshKey]);

  useEffect(() => {
    setColumns(buildColumns(selectedItems));
  }, [anetTypeOptions, selectedItems]);

  // 子组件提交 刷新summary。
  useEffect(() => {
  const handleMessage = (event) => {
    if (event.data?.type === "INSURANCE_REFRESH") {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };
  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, [pagination.current, pagination.pageSize, tableHead]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <Space>
          {commonFn.btnAuthorityFlag("New") && (
            <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
              New 
            </Button>
          )}
        </Space>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id"
         rowClassName={(record) => record.id === highlightRowId ? "highlight-row" : ""}
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
      <UploadModal
        ref={UploadModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      <UploadToExcelModal
        ref={UploadToExcelModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

       <UploadLiabilityModal
        ref={uploadLiabilityModalRef}
         onSuccess={() => {
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
        />
     {/* <InsuranceModal ref={insuranceModalRef}
      onRefresh={() => {
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }} /> */}
    </div>
  );
}
